// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import App from './App'
import router from './router'
import store from './store'
// import * as VueGoogleMaps from 'vue2-google-maps'

/* IMPORT MODULES */
import ModuleImage from '@/modules/ModuleImage/ModuleImage'

/* IMPORT GLOBAL COMPONENTS */
import BaseText from '@/components/BaseText/BaseText'
import BaseHeading from '@/components/BaseHeading/BaseHeading'
import BasePage from '@/components/BasePage/BasePage'
import BaseButton from '@/components/BaseButton/BaseButton'
import SvgLogo from '@/components/SvgLogo/SvgLogo'
import SectionSplit from '@/components/SectionSplit/SectionSplit'
import SectionLandingSplit from '@/components/SectionLandingSplit/SectionLandingSplit'
import SectionLargeImage from '@/components/SectionLargeImage/SectionLargeImage'
import SectionTextImage from '@/components/SectionTextImage/SectionTextImage'
import SectionPeople from '@/components/SectionPeople/SectionPeople'
import SectionRelated from '@/components/SectionRelated/SectionRelated'
import ViewLoader from '@/components/ViewLoader/ViewLoader'
import ContentMissing from '@/components/ContentMissing/ContentMissing'
/* IMPORT GLOBAL MIXINS */
import MixinViewport from '@/mixins/MixinViewport'

/* IMPORT DIRECTIVES */
import DirectiveOnRouteMatch from '@/directives/DirectiveOnRouteMatch'
import DirectiveUiClose from '@/directives/DirectiveUiClose'

// SET VARIABLES
Vue.config.productionTip = false
// const isProd = process.env.NODE_ENV === 'production'

/*
// GOOGLE ANALYTICS
Vue.use(VueAnalytics, {
  id: ['XXXXXXXX', 'XXXXXXXX'],
  router: router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})
*/

/* BIND STORE */
Vue.use(Vuex)

/* BIND UTILS */
Vue.use(Meta)
/*
Vue.use(VueGoogleMaps, {
  load: {
    key: ''
  },
  installComponents: false
})
Vue.component('GoogleMap', VueGoogleMaps.Map)
Vue.component('GoogleMapMarker', VueGoogleMaps.Marker)
*/
/* BIND COMPONENTS */
Vue.component('SvgLogo', SvgLogo)
Vue.component('SectionSplit', SectionSplit)
Vue.component('SectionLandingSplit', SectionLandingSplit)
Vue.component('SectionLargeImage', SectionLargeImage)
Vue.component('SectionTextImage', SectionTextImage)
Vue.component('SectionPeople', SectionPeople)
Vue.component('SectionRelated', SectionRelated)
Vue.component('BaseText', BaseText)
Vue.component('BaseHeading', BaseHeading)
Vue.component('BasePage', BasePage)
Vue.component('BaseButton', BaseButton)
Vue.component('ContentMissing', ContentMissing)
Vue.component('ViewLoader', ViewLoader)
/* BIND MODULES */
Vue.component('ModuleImage', ModuleImage)
/* BIND GLOBAL MIXINS */
Vue.mixin(MixinViewport)

/* BIND DIRECTIVES */
Vue.directive('click-route-match', DirectiveOnRouteMatch)
Vue.directive('click-ui-close', DirectiveUiClose)

/* eslint-disable */
const vm = new Vue({
  el: '#app',
  store: store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js